// import React, { createContext, useState, useContext, useEffect, useMemo } from "react";
// import axios from "axios";

// const AuthContext = createContext();
// const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

// const ADMIN_ROLES = ["superadmin", "admin", "manager", "operator","area_manager"];

// /* ---------------------------------
//    Helper to check profile completeness
// ---------------------------------- */
// const profileComplete = (u) =>
//   !!(u?.country && u?.province && u?.address);
//   // !!(u?.is_approved==true);


// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [admin, setAdmin] = useState(null);
//   const [loading, setLoading] = useState(true);

//   /* ---------------------------------
//      LOAD TOKEN ON REFRESH
//   ---------------------------------- */
//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     const adminToken = localStorage.getItem("adminToken");

//     if (adminToken) {
//       verifyAdminToken(adminToken);
//     } else if (token) {
//       verifyUserToken(token);
//     } else {
//       setLoading(false);
//     }
//   }, []);

//   /* ---------------------------------
//      REFRESH USER FROM BACKEND
//   ---------------------------------- */
//   const refreshUser = async () => {
//     const token = localStorage.getItem("token");
//     if (!token) return;

//     try {
//       const res = await axios.get(`${API_URL}/auth/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setUser(res.data);
//       localStorage.setItem("user", JSON.stringify(res.data));
//     } catch {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       setUser(null);
//     }
//   };

//   /* ---------------------------------
//      VERIFY USER TOKEN
//   ---------------------------------- */
//   const verifyUserToken = async (token) => {
//     try {
//       const res = await axios.get(`${API_URL}/auth/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setUser(res.data);
//       localStorage.setItem("user", JSON.stringify(res.data));
//     } catch {
//       localStorage.removeItem("token");
//       localStorage.removeItem("user");
//       setUser(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------------------------
//      VERIFY ADMIN TOKEN
//   ---------------------------------- */
//   const verifyAdminToken = async (token) => {
//     try {
//       const res = await axios.get(`${API_URL}/admin/auth/me`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       if (!res.data?.role) {
//         localStorage.removeItem("adminToken");
//         setAdmin(null);
//         return;
//       }

//       const role = res.data.role.toLowerCase();
//       if (!ADMIN_ROLES.includes(role)) {
//         localStorage.removeItem("adminToken");
//         setAdmin(null);
//         return;
//       }

//       setAdmin({ ...res.data, role });
//     } catch {
//       localStorage.removeItem("adminToken");
//       setAdmin(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* ---------------------------------
//      UPDATE USER LOCALLY
//   ---------------------------------- */
//   const updateUser = (updatedData) => {
//     setUser((prev) => ({ ...prev, ...updatedData }));
//     localStorage.setItem("user", JSON.stringify({ ...user, ...updatedData }));
//   };

//   /* ---------------------------------
//      LOGIN — fetch /auth/me immediately
//   ---------------------------------- */
//   const login = async (token, userData) => {
//     localStorage.setItem("token", token);


//     // ONE-TIME LOGIN TOAST FLAG
//     sessionStorage.setItem("justLoggedIn", "1");

//     await refreshUser();
//   };

//   const adminLogin = (token, adminData) => {
//     const role = adminData.role?.toLowerCase();
//     if (!ADMIN_ROLES.includes(role)) return;

//     localStorage.setItem("adminToken", token);
//     setAdmin({ ...adminData, role });
//   };

//   /* ---------------------------------
//      LOGOUT
//   ---------------------------------- */
//   const logout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("user");
//     setUser(null);
//     window.location.href = "/login";
//   };

//   const adminLogout = () => {
//     localStorage.removeItem("adminToken");
//     setAdmin(null);
//     window.location.href = "/admin/login";
//   };

//   /* ---------------------------------
//      Derived: profile completeness
//   ---------------------------------- */
//   const isProfileComplete = useMemo(() => profileComplete(user), [user]);

//   return (
//     <AuthContext.Provider
//       value={{
//         user,
//         admin,
//         loading,
//         login,
//         adminLogin,
//         logout,
//         adminLogout,
//         updateUser,
//         refreshUser,
//         isProfileComplete,
//       }}
//     >
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);

import React, { createContext, useState, useContext, useEffect, useMemo } from "react";
import axios from "axios";

const AuthContext = createContext();
const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

const ADMIN_ROLES = ["superadmin", "admin", "manager", "operator", "area_manager"];

/* ---------------------------------
   Helper to check profile completeness
---------------------------------- */
const profileComplete = (u) =>
  !!(u?.country && u?.province && u?.address);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ---------------------------------
     LOAD TOKEN ON REFRESH
  ---------------------------------- */
  useEffect(() => {
    const initAuth = async () => {
      const token = localStorage.getItem("token");
      const adminToken = localStorage.getItem("adminToken");
      const storedUser = localStorage.getItem("user");

      // ✅ Check user token FIRST (priority for main app)
      if (token && storedUser) {
        try {
          const parsedUser = JSON.parse(storedUser);
          
          // Set user immediately from localStorage
          setUser(parsedUser);
          
          // Set loading to false so UI can render
          setLoading(false);
          
          // Verify token in background
          const res = await axios.get(`${API_URL}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          
          // Update with fresh data from server
          setUser(res.data);
          localStorage.setItem("user", JSON.stringify(res.data));
        } catch (error) {
          console.error("Token verification failed:", error);
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          setUser(null);
          setLoading(false);
        }
      } 
      // Check admin token only if no user token
      else if (adminToken) {
        await verifyAdminToken(adminToken);
      } 
      else {
        setLoading(false);
      }
    };

    initAuth();
  }, []);

  /* ---------------------------------
     REFRESH USER FROM BACKEND
  ---------------------------------- */
  const refreshUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    try {
      const res = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUser(res.data);
      localStorage.setItem("user", JSON.stringify(res.data));
    } catch (error) {
      console.error("Refresh user failed:", error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
    }
  };

  /* ---------------------------------
     VERIFY USER TOKEN
  ---------------------------------- */
  const verifyUserToken = async (token) => {
    try {
      const res = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUser(res.data);
      localStorage.setItem("user", JSON.stringify(res.data));
    } catch (error) {
      console.error("Token verification failed:", error);
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------------------------
     VERIFY ADMIN TOKEN
  ---------------------------------- */
  const verifyAdminToken = async (token) => {
    try {
      const res = await axios.get(`${API_URL}/admin/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.data?.role) {
        localStorage.removeItem("adminToken");
        setAdmin(null);
        setLoading(false);
        return;
      }

      const role = res.data.role.toLowerCase();
      if (!ADMIN_ROLES.includes(role)) {
        localStorage.removeItem("adminToken");
        setAdmin(null);
        setLoading(false);
        return;
      }

      setAdmin({ ...res.data, role });
      setLoading(false);
    } catch (error) {
      console.error("Admin token verification failed:", error);
      localStorage.removeItem("adminToken");
      setAdmin(null);
      setLoading(false);
    }
  };

  /* ---------------------------------
     UPDATE USER LOCALLY
  ---------------------------------- */
  const updateUser = (updatedData) => {
    const newUserData = { ...user, ...updatedData };
    setUser(newUserData);
    localStorage.setItem("user", JSON.stringify(newUserData));
  };

  /* ---------------------------------
     LOGIN — set user immediately
  ---------------------------------- */
  const login = async (token, userData) => {
    // ✅ Clear any admin token when user logs in
    localStorage.removeItem("adminToken");
    
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    
    // Set user immediately from login response
    setUser(userData);

    // ONE-TIME LOGIN TOAST FLAG
    sessionStorage.setItem("justLoggedIn", "1");

    // Optionally refresh to get latest data
    try {
      const res = await axios.get(`${API_URL}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data);
      localStorage.setItem("user", JSON.stringify(res.data));
    } catch (error) {
      console.error("Failed to refresh user after login:", error);
      // User is still set from login response, so this is not critical
    }
  };

  const adminLogin = (token, adminData) => {
    const role = adminData.role?.toLowerCase();
    if (!ADMIN_ROLES.includes(role)) return;

    // ✅ Clear user token when admin logs in
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    localStorage.setItem("adminToken", token);
    setAdmin({ ...adminData, role });
  };

  /* ---------------------------------
     LOGOUT
  ---------------------------------- */
  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    sessionStorage.removeItem("justLoggedIn");
    setUser(null);
    window.location.href = "/auth?mode=login";
  };

  const adminLogout = () => {
    localStorage.removeItem("adminToken");
    setAdmin(null);
    window.location.href = "/admin/login";
  };

  /* ---------------------------------
     Derived: profile completeness
  ---------------------------------- */
  const isProfileComplete = useMemo(() => profileComplete(user), [user]);

  return (
    <AuthContext.Provider
      value={{
        user,
        admin,
        loading,
        login,
        adminLogin,
        logout,
        adminLogout,
        updateUser,
        refreshUser,
        isProfileComplete,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);